import axios from 'axios';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "../../../scss/Components/_modal.scss"
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { toast } from 'react-toastify';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';

function ModalUDelete(props) {
    const {
        userModalDeleteString,
        userMDNameString,
        userMDEmailString,
        userMDEDateString,
        modalYesString,
        modalNoString,
    } = useTranslationHook();

    var deleteUserName = localStorage.getItem("userNameToDelete");
    var deleteUserEmail = localStorage.getItem("userEmailToDelete");
    var deleteUserCreatedDate = localStorage.getItem("userCreatedDateToDelete");

    var deleteUserId = localStorage.getItem("userIdToDelete");

    function deleteUser() {
        customAxios.request({
            url: `${GlobalVariables.getURL()}delete/${deleteUserId}`,
            method: 'delete',
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        }).then((response) => {
            console.log(response.data);
            hideS();
        }, (error) => {
            console.log(error);
            getToast({ status: 'error', title: 'Error al eliminar usuario. Vuelve a intentarlo.' });
        });
    }

    function hideS() {
        props.onHide();
        getToast({ status: 'success', title: 'Usuario eliminado exitosamente en la base de datos.' });
        props.getUsers();
    }

    function hideN() {
        props.onHide();
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="modal-backdrop"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    {userModalDeleteString}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className='delete-info'><strong>{userMDNameString}:</strong> {deleteUserName}</span><br />
                <span className='delete-info'><strong>{userMDEmailString}:</strong> {deleteUserEmail}</span><br />
                <span className='delete-info'><strong>{userMDEDateString}:</strong> {deleteUserCreatedDate}</span>
            </Modal.Body>
            <Modal.Footer>
                <button className='modal-button' onClick={() => { deleteUser() }}><FontAwesomeIcon icon={faWarning} /> {modalYesString}</button>
                <button className='modal-button no' onClick={() => { hideN() }}><FontAwesomeIcon icon={faCircleChevronLeft} /> {modalNoString}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalUDelete;